// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1{margin:0 0 0.25rem 0}.block>.row:nth-child(2)>.col:first-child>.row:first-child>.col{margin:0}.block>.row:nth-child(2)>.col:first-child>.row:nth-child(2)>.col{margin-top:10px}.block>.row:nth-child(2){margin-bottom:20px}ul.downloads{list-style-type:none;padding:0}ul.downloads a{cursor:pointer;border-bottom:0}ul.downloads a span{border-bottom:1px solid #1b3fea}ul.downloads a:hover svg path{fill:#617af0}ul.downloads svg{vertical-align:middle}\n", ""]);
// Exports
module.exports = exports;
